const handleLogin = () => {
  const uri = `https://sellercentral.amazon.com/apps/authorize/consent?application_id=${process.env.REACT_APP_AMAZON_CLIENT_ID}&version=beta`;
  window.location.href = uri;
};

export default {
  handleLogin,
};
